import { AfterViewInit, Component, ElementRef, EventEmitter, HostListener, Input, OnDestroy, Output } from '@angular/core';
import { SwitcherContentComponent } from '../switcher-content/switcher-content.component';
import { CommonUtility } from '../../../../utility/common.utility';

@Component({
  selector: 'app-switcher-flyout',
  templateUrl: './switcher-flyout.component.html',
  styleUrls: ['./switcher-flyout.component.scss'],
  standalone: true,
  imports: [SwitcherContentComponent],
})
export class SwitcherFlyoutComponent implements AfterViewInit, OnDestroy {
  @Input() public flyoutTop: string = '';
  @Input() public flyoutLeft: string = '';
  @Input() public ariaLabel: string = '';
  @Output() public closed: EventEmitter<void> = new EventEmitter<void>();

  constructor(private elementRef: ElementRef<HTMLElement>) {}

  public ngAfterViewInit(): void {
    CommonUtility.activateFocusTrap(this.elementRef.nativeElement, { initialFocus: false, allowOutsideClick: true });
  }

  public ngOnDestroy(): void {
    CommonUtility.deactivateFocusTrap();
  }

  @HostListener('keydown.escape')
  public close(): void {
    this.closed.emit();
  }
}
